import pick from 'lodash/pick'
import D2C_ServiceWeb from './Web'
import store from '@/store'

class D2C_ServiceNginx extends D2C_ServiceWeb {
  isEdge = true
  static objectType = 'serviceType'
  static active = true
  static order = 30
  static typeName = 'nginx'
  static typeTitle = 'Nginx'
  static color = '#008833'
  static fields = {
    ...D2C_ServiceWeb.fields,
    configs: {
      ...D2C_ServiceWeb.fields.configs,
      default: [
        {name: 'nginx.conf', text: require('raw-loader!@/assets/configs/nginx-nginx.conf').default, custom: false},
      ],
    },
    hosts: {
      ...D2C_ServiceWeb.fields.hosts,
      selector: {
        default: ['node'],
      },
    },
    image: {
      ...D2C_ServiceWeb.fields.image,
      default: 'd2cio/nginx',
    },
    ports: {
      ...D2C_ServiceWeb.fields.ports,
      default: [
        {protocol: 'TCP', value: 80},
        {protocol: 'TCP', value: 443},
      ],
    },
    remoteAccess: {
      ...D2C_ServiceWeb.fields.remoteAccess,
      default: true,
    },
    services: {
      default: [],
      label: 'Configure services',
      ownCertificates: true,
      path: 'services',
      required: false,
      serviceConfig: require('raw-loader!@/assets/configs/nginx.tpl').default,
      serviceConfigFields: ['cert', 'config', 'domains', 'https', 'id', 'key', 'name', 'secure', 'static'],
      serviceConfigVariables: ['$serviceName', '$servicePort', '$serviceSSLCiphers', '$serviceDomains', '$serviceNginxCert', '$serviceNginxHTTPS', '$serviceNginxKey', '$serviceSSLProtocols'],
      serviceConfigLimit: 0,
      serviceConfigSuffix: '-www',
      serviceMethod: 'serve',
      servicePortProtocols: ['TCP', 'UDP'],
      serviceConfigModes: [
        {value: 'proxy', text: 'Proxy'},
        {value: 'uwsgi', text: 'uWSGI'},
        {value: 'fastcgi', text: 'FastCGI'},
      ],
      syntax: 'nginx',
      validate(value) {
        const errors = {}
        let hasErrors = false
        for (const config of value) {
          errors[config.id] = {}
          if (config.domains.length) {
            const serviceName = config.name.toLowerCase()
            const shortId = store.getters.account.shortId
            const baseDomain = store.state.config.domain
            const d2cDomain = `${serviceName}-www.${shortId}.at.${baseDomain}`
            const invalidNames = []
            for (const domain of config.domains) {
              if (!/^[a-z0-9*.-]+\.+[a-z0-9.-]+$/.test(domain)) {
                invalidNames.push(domain)
              }
            }
            if (invalidNames.length) {
              hasErrors = true
              errors[config.id].domains = `Invalid domain names: ${invalidNames.join(', ')}`
            }
            if (config.domains.length > 1 && config.domains.includes(d2cDomain)) {
              hasErrors = true
              errors[config.id].domains = 'You can`t use our domain with yours'
            }
          } else {
            if (config.https !== 'none') {
              hasErrors = true
              errors[config.id].domains = 'You must set domain names for your HTTPS certificates'
            }
          }
          // if (config.https === 'own') {
          //   if (!config.cert) {
          //     hasErrors = true
          //     errors[config.id].cert = 'Your HTTPS certificate must be uploaded'
          //   }
          //   if (!config.key) {
          //     hasErrors = true
          //     errors[config.id].key = 'Your HTTPS key must be uploaded'
          //   }
          // }
        }
        return hasErrors ? errors : null
      },
      prepare(value) {
        return value.map(config => {
          return pick(config, ['cert', 'config', 'domains', 'https', 'id', 'key', 'name', 'secure', 'static'])
        })
      },
      creating: {},
      updating: {},
      updatingServices: {},
      importing: {
        hidden: true,
      },
    },
    version: {
      ...D2C_ServiceWeb.fields.version,
      default: '1.19',
      enum: ['1.16', '1.17', '1.18', '1.19'],
    },
    volumes: {
      ...D2C_ServiceWeb.fields.volumes,
      demo: [
        {src: '/etc/letsencrypt', dst: '/etc/letsencrypt', sync: false},
        {src: '/ebs/containers/$serviceName/configs', dst: '/etc/nginx/conf.d', sync: false},
      ],
    },
  }
}

export default D2C_ServiceNginx
